import { createStore } from 'satcheljs';
import { ObservableMap } from 'mobx';
import { BlockOnSendAttachmentsTelemetryData } from './schema/BlockOnSendAttachmentsTelemetryData';
import { BlockOnSendAttachmentsTelemetryStore } from './schema/BlockOnSendAttachmentsTelemetryStore';

const defaultStore: BlockOnSendAttachmentsTelemetryStore = {
    telemetryDataForFailedValidation: new ObservableMap<
        string,
        BlockOnSendAttachmentsTelemetryData
    >(),
};

export const getStore = createStore('blockOnSendAttachmentsTelemetryStore', defaultStore);
